import * as angular from "angular";
import {AbsenceReasonSettings} from "../models/absence-reason-settings.model";

export class AbsenceReasonsDialogsService {

  constructor(private $mdDialog) {
  }

  createAbsenceReason(event) {
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-absence-reason-dialog.html').default,
      controller: this._buildController('Create New Absence Reason', 'Create', {name: undefined}),
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editAbsenceReason(event, absenceReason: AbsenceReasonSettings) {
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-absence-reason-dialog.html').default,
      controller: this._buildController('Edit Absence Reason', 'Edit', absenceReason),
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  private _buildController(header: string, action: string, absenceReason) {
    const self = this;
    return function ($scope) {

      $scope.header = header;
      $scope.action = action;
      $scope.cancel = self.$mdDialog.cancel;
      $scope.absenceReason = absenceReason;
      $scope.hasFixedDuration = !!absenceReason.durationInMinutes;
      $scope.durationInMs = $scope.hasFixedDuration ? absenceReason.durationInMinutes * 60000 : 0;

      // ******************************
      // External methods
      // ******************************

      $scope.onToggleFixedDuration = () => {
        if (!$scope.hasFixedDuration) {
          $scope.durationInMs = 0;
          $scope.durationError = false;
        }
      }

      $scope.onDurationChange = (durationInMs) => {
        $scope.durationInMs = durationInMs;
        $scope.durationError = !getDurationInMinutes();
      }

      $scope.submit = (form) => {
        if (form) {
          form.$setSubmitted(true);

          const durationInMinutes = getDurationInMinutes();
          $scope.durationError = $scope.hasFixedDuration && !durationInMinutes;

          if (form.$valid && !$scope.durationError) {
            $scope.absenceReason.durationInMinutes = durationInMinutes || null;
            self.$mdDialog.hide($scope.absenceReason);
          }

        }
      }

      // ******************************
      // Internal methods
      // ******************************

      function getDurationInMinutes() {
        if (!$scope.hasFixedDuration) {
          return 0;
        }

        const durationInMinutes = Math.round(($scope.durationInMs || 0) / 60000);

        return durationInMinutes > 0 ? durationInMinutes : 0;
      }

    }
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('absenceReasonsDialogsService', AbsenceReasonsDialogsService);
